var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#070A26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 12.7188C21.25 12.5979 21.1521 12.5 21.0312 12.5H10.9688C10.8479 12.5 10.75 12.5979 10.75 12.7187V13.375C10.75 13.4958 10.8479 13.5938 10.9687 13.5938H21.0312C21.1521 13.5938 21.25 13.4958 21.25 13.375V12.7188Z",
    fill: "#070A26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 15.6719C10.75 15.5511 10.8479 15.4531 10.9687 15.4531H21.0312C21.1521 15.4531 21.25 15.5511 21.25 15.6719V16.3281C21.25 16.4489 21.1521 16.5469 21.0312 16.5469H10.9688C10.8479 16.5469 10.75 16.4489 10.75 16.3281V15.6719Z",
    fill: "#070A26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 18.625C10.75 18.5042 10.8479 18.4062 10.9687 18.4062H21.0312C21.1521 18.4062 21.25 18.5042 21.25 18.625V19.2812C21.25 19.4021 21.1521 19.5 21.0312 19.5H10.9688C10.8479 19.5 10.75 19.4021 10.75 19.2812V18.625Z",
    fill: "#070A26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.fe000fdc30a9dc391cf463255c295eaf.svg";
export { ForwardRef as ReactComponent };